export const ThemeType = {
	dark: 'dark',
	light: 'light',
} as const;
